import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardRedirectComponent } from './components/dashboard/dashboard-redirect/dashboard-redirect.component';
import { SummaryComponent } from './components/dashboard/summary/summary.component';
import { ExamComponent } from './components/dashboard/exam/exam.component';
import { ExamFoldersComponent } from './components/dashboard/exam-folders/exam-folders.component';
import { FormsSetupComponent } from './components/dashboard/forms-setup/forms-setup.component';
import { QuestionsAndAnswersComponent } from './components/dashboard/questions-and-answers/questions-and-answers.component';
import { ReportsComponent } from './components/dashboard/reports/reports.component';
import { ExamScheduleComponent } from './components/dashboard/exam-schedule/exam-schedule.component';
import { StartExamComponent } from './components/dashboard/exam/start-exam/start-exam.component';
import { AuthGuard } from './guards/auth.guard';
import { PermissionGuard } from './guards/permission.guard';
import { Permissions } from './permissions.enum';
import { SettingsComponent } from './components/dashboard/settings/settings.component';
import { ExamViolationsComponent } from './components/dashboard/exam-violations/exam-violations.component';

export const appRoutes: Routes = [
  { path: '', component: LoginComponent },
  { 
    path: 'dashboard', 
    component: DashboardComponent, 
    canActivate: [AuthGuard], 
    children: [
      { path: '', component: DashboardRedirectComponent },
      { 
        path: 'summary', 
        component: SummaryComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.Summary }
      },
      { 
        path: 'exam-folders', 
        component: ExamFoldersComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.ExamFolder }
      },
      { 
        path: 'forms-setup', 
        component: FormsSetupComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.FormSetup }
      },
      { 
        path: 'questions-and-answers', 
        component: QuestionsAndAnswersComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.QuestionsAndAnswers }
      },
      { 
        path: 'reports', 
        component: ReportsComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.Report }
      },
      { 
        path: 'exam-schedule', 
        component: ExamScheduleComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.ExamSchedule }
      },
      { 
        path: 'exam-violations', 
        component: ExamViolationsComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.ExamViolations }
      },
      { 
        path: 'exam', 
        component: ExamComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.Exam }
      },
      { 
        path: 'start-exam', 
        component: StartExamComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.Exam }
      },
      { 
        path: 'settings', 
        component: SettingsComponent, 
        canActivate: [PermissionGuard], 
        data: { permission: Permissions.Settings }
      },
    ]
  },
  { path: '**', redirectTo: '' }  
];
